// client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import axios from "axios";

// Import Bootstrap JS explicitly
import * as bootstrap from 'bootstrap'; // Add this line

// Set Axios default to include credentials
axios.defaults.withCredentials = true;

// Make bootstrap available globally (optional, for debugging)
window.bootstrap = bootstrap;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();